import { ECO_CART_STORAGE_KEY, MAX_CART_NUM, MIN_CART_NUM } from './const';
import { ItfEcoCartItem } from './type.d';

// 非登录态 - 游客， 将数据存储在localStorage中
// 初始化： 获取游客购物车信息
export const STORAGE_GET_CARTS = () => {
    if (typeof window === 'undefined') return [] as ItfEcoCartItem[];
    const locale = window?.location?.pathname?.split('/')?.[1] || 'us';
    const obj = { [locale]: [] as ItfEcoCartItem[] };
    const data: { [key: string]: ItfEcoCartItem[] } = JSON.parse(localStorage.getItem(ECO_CART_STORAGE_KEY) || JSON.stringify(obj));
    if (data && data?.[locale] && Array.isArray(data?.[locale]) && data?.[locale]?.length > 0) {
        return [...(data?.[locale] as ItfEcoCartItem[])];
    }
    return [] as ItfEcoCartItem[];
};

// 交互时： 存储游客购物车信息
export const STORAGE_SET_CARTS = (data: ItfEcoCartItem[]) => {
    if (typeof window === 'undefined' || !Array.isArray(data)) return;
    const locale = window?.location?.pathname?.split('/')?.[1] || 'us';
    localStorage.setItem(ECO_CART_STORAGE_KEY, JSON.stringify({ [locale]: data || ([] as ItfEcoCartItem[]) }));
};

// 登录时： 合并购物车，并清空游客购物车信息
export const STORAGE_REMOVE_CARTS = () => {
    if (typeof window === 'undefined') return;
    const locale = window?.location?.pathname?.split('/')?.[1] || 'us';
    localStorage.setItem(ECO_CART_STORAGE_KEY, JSON.stringify({ [locale]: [] as ItfEcoCartItem[] }));
};

// 添加时： 增量购物车信息 - 页面上添加按钮 或者 购物车中的 +
export const STORAGE_INCREASE_CARTS = (data: ItfEcoCartItem[]) => {
    if (!Array.isArray(data)) return;
    const ext: ItfEcoCartItem[] = STORAGE_GET_CARTS();
    data.forEach((item: ItfEcoCartItem) => {
        const target: ItfEcoCartItem | undefined = ext.find((list: ItfEcoCartItem) => list.variantId === item.variantId);
        if (target) {
            target.quantity =
                target.inventoryPolicy === 'continue'
                    ? Math.min(target.quantity + item.quantity, MAX_CART_NUM)
                    : Math.min(target.quantity + item.quantity, MAX_CART_NUM, target.inventoryQuantity);
        } else {
            ext.unshift(item);
        }
    });
    STORAGE_SET_CARTS(ext);
};

// 更新时： 全量购物车信息 - 购物车中的 - 或者 购物车中的 🗑️
export const STORAGE_UPDATE_CARTS = (data: ItfEcoCartItem) => {
    if (!data?.variantId) return;
    const ext: ItfEcoCartItem[] = STORAGE_GET_CARTS();
    const target: ItfEcoCartItem | undefined = ext?.find((x: ItfEcoCartItem) => x.variantId === data.variantId);
    if (target) {
        target.quantity = data.quantity;
    }
    STORAGE_SET_CARTS(ext?.filter((x: ItfEcoCartItem) => x.quantity > MIN_CART_NUM));
};
